import React, { useState } from 'react';
import { Button, TextField, Container, Typography, Box, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
const CreateUser = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const theme = useTheme();
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = { name, email, password };

    try {
      const response = await fetch(`${process.env.REACT_APP_BACK_END_URL}/firebase_registration`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),

      });

      if (response.ok) {
        console.log('Form data submitted successfully');
        console.log(await response.json());
      } else {
        console.log(response);
        console.log('Form submission failed');
      }
    } catch (error) {
      console.log('An error occurred:', error);
    }
  };

  return (
    <Container component="main" maxWidth="xs" position="relative">
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'row',
          color: theme.palette.text.primary,
        }}
      >
        <Box
          sx={{
            width: '50%',
            backgroundColor: theme.palette.primary.main,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(2),
          }}
        >
          <Typography variant="h4" sx={{ color: 'white' }}>
            Bizzence
          </Typography>
          <Typography variant="subtitle1" sx={{ color: 'white' }}>
            Elevating your business sense and science
          </Typography>
        </Box>
        <Box
          sx={{
            width: '50%',
            backgroundColor: theme.palette.white[500],
            backgroundImage: 'url("https://images.unsplash.com/photo-1560221328-12fe60f83ab8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1174&q=80")',
            backgroundPosition: 'center', // Center the image
            backgroundRepeat: 'no-repeat', // Do not repeat the image
            backgroundSize: 'cover', // Resize the background image to cover the entire container
          }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80vh',
          zIndex: 1,
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          borderRadius: '4px',
          padding: theme.spacing(2),
        }}
      >
        <Box sx={{ width: '100%', textAlign: 'left', zIndex: 2 }}>
          <Typography component="h1" variant="h5" sx={{ color: theme.palette.white[100], zIndex: 2 }}>
            Register
          </Typography>
        </Box>
        <form onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="name"
            label="Name"
            name="name"
            autoComplete="name"
            autoFocus
            value={name}
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: theme.palette.white[100], // or any other color you'd prefer
              },
            }}
            InputProps={{
              sx: {
                color: theme.palette.text.secondary,
              },
            }}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            value={email}
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: theme.palette.white[100], // or any other color you'd prefer
              },
            }}
            InputProps={{
              sx: {
                color: theme.palette.text.secondary,
              },
            }}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: theme.palette.white[100], // or any other color you'd prefer
              },
            }}
            InputProps={{
              sx: {
                color: theme.palette.text.secondary,
              },
            }}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Grid container justifyContent="center" mt="15px">
            <Button
              type="submit"

              variant="contained"

              style={{ backgroundColor: 'white', color: 'black', }}
            >
              Sign Up
            </Button>
          </Grid>
        </form>
      </Box>
    </Container>
  );

}

export default CreateUser;
